







import { Component, Vue } from 'vue-property-decorator'
import { matchFieldsLocalisationKeys } from '@/features/matchFields/matchFields.localisation'

@Component
export default class MatchFieldsHeader extends Vue {
  private translations = matchFieldsLocalisationKeys
}
